import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-590c67a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = { class: "modal-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "设置", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-onetabAvatar" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "login-text" }, "登录 / 注册"),
  /*#__PURE__*/_createElementVNode("span", null, "登录后同步设置")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "email" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "modal-right" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "close-btn" }

import { ref, onMounted, onBeforeUnmount } from 'vue';
import CommonConfig from '@/components/CommonConfig.vue';
import Appearance from '@/components/Appearance.vue';
import SearchEngine from '@/components/SearchEngine';
import Notification from '@/components/Notification';
import AboutUs from '@/components/AboutUs';
import LoginRegistry from '@/components/LoginRegistry.vue';
import Account from '@/components/Account';
import Ucenter from '@/components/Ucenter';
import { Close } from '@rafter/icon';
import { getLocalConfig } from '@/utils';
import { user } from '@/store/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingModal',
  props: {
  selected: {
    type: Object,
    default: () => {
      return {
        name: '通用',
        value: 'common',
      }
    },
  },
},
  emits: ['handleClose'],
  setup(__props, { emit: emits }) {

const props = __props;




const selectedItem = ref({
  name: '通用',
  value: 'common',
});
const isShow = ref(false);
const itemList = [
  {
    name: '通用',
    value: 'common',
    icon: 'icon-onetabtongyong',
  },
  {
    name: '外观',
    value: 'appearance',
    icon: 'icon-onetabwaiguan',
  },
  {
    name: '搜索引擎',
    value: 'searchEngine',
    icon: 'icon-onetabsousuoyinqing',
  },
  // {
  //   name: '消息通知',
  //   value: 'notification',
  // },
  {
    name: '关于我们',
    value: 'aboutUs',
    icon: 'icon-onetabguanyuwomen',
  },
];

onMounted(() => {
  selectedItem.value.name = props.selected.name;
  selectedItem.value.value = props.selected.value;
});

const handleItem = (item: { name: string; value: string }) => {
  selectedItem.value = item;
};
const handleClose = () => {
  isShow.value = false;
  setTimeout(() => {
    emits('handleClose');
  }, 150);
};
const handleLogin = () => {
  selectedItem.value = {
    name: '登录',
    value: 'login',
  };
};
const handleUcenter = () => {
  selectedItem.value = {
    name: '账号',
    value: 'ucenter',
  };
};
onMounted(() => {
  isShow.value = true;
  console.log('-----settingModal----');
  document.addEventListener('keydown', handleKeyDown);
});
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: _withModifiers(handleClose, ["self"])
  }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (!_unref(user).token)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "login",
                      onClick: handleLogin
                    }, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "user-info",
                      onClick: handleUcenter
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: _unref(user).avatar
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(user).email), 1)
                    ])),
                _createElementVNode("div", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(itemList, (item) => {
                    return _createElementVNode("div", {
                      key: item.name,
                      class: _normalizeClass({ item: true, active: selectedItem.value.name === item.name }),
                      onClick: ($event: any) => (handleItem(item))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass({ iconfont: true, [item.icon]: true })
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 10, _hoisted_11)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(selectedItem.value.name), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(Close), {
                      size: 14,
                      onClick: handleClose
                    })
                  ])
                ]),
                (selectedItem.value.value === 'common')
                  ? (_openBlock(), _createBlock(CommonConfig, { key: 0 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'appearance')
                  ? (_openBlock(), _createBlock(Appearance, { key: 1 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'searchEngine')
                  ? (_openBlock(), _createBlock(_unref(SearchEngine), { key: 2 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'notification')
                  ? (_openBlock(), _createBlock(_unref(Notification), { key: 3 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'aboutUs')
                  ? (_openBlock(), _createBlock(_unref(AboutUs), { key: 4 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'login')
                  ? (_openBlock(), _createBlock(LoginRegistry, {
                      key: "login",
                      onLogged: handleUcenter
                    }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'account')
                  ? (_openBlock(), _createBlock(_unref(Account), { key: 6 }))
                  : _createCommentVNode("", true),
                (selectedItem.value.value === 'ucenter')
                  ? (_openBlock(), _createBlock(_unref(Ucenter), {
                      key: 7,
                      onLogout: handleLogin
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})